var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import * as R from 'ramda';
import dateFns from 'date-fns';

var spotlightHandler = function spotlightHandler(_ref) {
  var term = _ref.term,
      fields = _ref.fields;
  return function (item) {
    return R.any(function (field) {
      var itemValue = R.is(Function, field.accessor) ? field.accessor(item) : R.prop(field.accessor, item);
      if (R.is(Number, itemValue)) return R.contains(R.toLower(term), R.toLower(R.toString(itemValue)));
      return R.contains(R.toLower(term), R.toLower(itemValue));
    })(fields);
  };
};

export var reduceChildren = function reduceChildren(node, itemsIndexById) {
  var func = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : R.flip(R.prepend);
  var acc = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

  if (R.isNil(node.parentId)) return acc;
  var nextNode = R.prop(node.parentId)(itemsIndexById);
  if (R.isNil(nextNode)) return acc;
  return reduceChildren(nextNode, itemsIndexById, func, func(acc, nextNode));
};

export var spotlightScopeListEngine = function spotlightScopeListEngine(_ref2) {
  var _ref2$term = _ref2.term,
      term = _ref2$term === undefined ? '' : _ref2$term,
      fields = _ref2.fields,
      items = _ref2.items,
      itemsById = _ref2.itemsById,
      noPath = _ref2.noPath,
      hasPath = _ref2.hasPath;

  var isSelected = R.pipe(R.prop('isSelected'), R.equals(true));
  var getFields = R.pipe(R.defaultTo([]), R.filter(isSelected), R.values);

  return R.reduce(function (acc, item) {
    if (spotlightHandler({ term: term, fields: getFields(fields) })(item)) {
      if (noPath) return [].concat(acc, [item]);
      return [].concat(acc, [_extends({}, item, {
        nodePath: hasPath ? R.propOr([], 'path')(item) : reduceChildren(item, itemsById)
      })]);
    }
    return acc;
  }, [])(items);
};

export var withBlank = function withBlank(func) {
  return function (Component) {
    return function (props) {
      if (R.pipe(func, R.prop('isBlank'))(props)) return null;
      return React.createElement(Component, props);
    };
  };
};

export var getLight = R.path(['palette', 'tertiary', 'light']);
export var getDark = R.path(['palette', 'tertiary', 'dark']);

export var getIsRtl = function getIsRtl(theme) {
  return R.equals('rtl', R.prop('direction', theme));
};
export var newDate = function newDate(stringDate) {
  var date = new Date(stringDate);
  return dateFns.addMinutes(date, date.getTimezoneOffset());
};